module.exports = __webpack_public_path__ + "img/BRAVO_2.a29a76f6.jpg";